import React from 'react';

type Store = {
	isAutoApproval: boolean;
	setAutoApproval: React.Dispatch<React.SetStateAction<boolean>>;
};

export const AutoApprovalContext = React.createContext<Store>({
	isAutoApproval: false,
} as Store);

export const useAutoApprovalContext = () => React.useContext(AutoApprovalContext);
